import React from 'react';
import {
    Grid,
    Card,
    CardContent,
    makeStyles,
    Typography,
    Divider,
    Fab
} from '@material-ui/core';
import {
    NearMeRounded as LocalizacaoIcon,
    PhoneRounded as TelefoneIcon,
    CalendarTodayRounded as CalendarioIcon
} from '@material-ui/icons';

const styles = makeStyles(theme => ({
    divider: {
        margin: '10px 0px'
    }
}));

function CardServico(
    {
        servico,
        color,
        disabled
    }
) {
    const classes = styles();

    return (
        <Card>
            <CardContent>
                <Grid container>
                    <Grid item
                        xs={6}>
                        <Typography variant="body1">
                            Serviços
                        </Typography>
                    </Grid>
                    {
                        disabled ?
                            <Grid item
                                xs={6}>
                                <Typography variant="caption"
                                    component='p'
                                    align='right'>
                                    N° {servico.numero}
                                </Typography>
                            </Grid> :
                            <Grid item
                                xs={6}>
                                <Typography variant="caption"
                                    color='primary'>
                                    Dúvidas ou alterações
                                </Typography>
                            </Grid>
                    }
                </Grid>
                <Grid container>
                    <Grid item
                        xs={12}>
                        <Typography variant="caption">
                            {servico.servico}
                        </Typography>
                    </Grid>
                </Grid>
                <Divider className={classes.divider} />
                <Grid container>
                    <Grid item
                        xs={2}>
                        <Fab color='primary'
                            size='small'
                            disabled={disabled}>
                            <LocalizacaoIcon color={color} />
                        </Fab>
                    </Grid>
                    <Grid item
                        xs={10}>
                        <Typography variant="body1">
                            {servico.nomeConcessionaria}
                        </Typography>
                    </Grid>
                    <Grid item
                        xs={12}>
                        <Typography variant="caption">
                            {servico.enderecoConcessionaria}
                        </Typography>
                    </Grid>
                </Grid>
                <Divider className={classes.divider} />
                <Grid container>
                    <Grid item
                        xs={2}>
                        <Fab color='primary'
                            href='tel:08009791010'
                            size='small'
                            disabled={disabled}>
                            <TelefoneIcon color={color} />
                        </Fab>
                    </Grid>
                    <Grid item
                        xs={4}>
                        <Typography variant="caption">
                            {servico.contato}
                        </Typography>
                    </Grid>
                    <Grid item
                        xs={2}>
                        <Fab color='primary'
                            size='small'
                            disabled={disabled}>
                            <CalendarioIcon color={color} />
                        </Fab>
                    </Grid>
                    <Grid item
                        xs={4}>
                        <Typography variant="caption">
                            {servico.data} - {servico.hora}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default CardServico;